import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { setStorageAmountParams } from '../utils';

export const useExtractUrlParams = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // extract params from /p/
    const match = location.pathname.match(/^\/p\/([^/]+)$/);

    // Extract the 'amount' parameter from the search string
    const searchParams = new URLSearchParams(location.search);
    const amount = searchParams.get('amount');

    if (amount) {
      setStorageAmountParams(amount);
    }

    if (match) {
      const value = match[1];
      history.push(`/payment/${value}`);
    }
  }, [location, history]);
};
